class MC_ScrollToExpert {
 constructor() {
  this.initScroll();
 }

 initScroll() {
  let scrollButton = document.querySelector('.expert_biography');
  if(!scrollButton) {
   return
  }
  let scrollElement = document.querySelector('.article-expert');
  let header = document.querySelector('#header');
  scrollButton.addEventListener('click', function (e) {
   e.preventDefault();
   let scrollElementTop = scrollElement.getBoundingClientRect().top;
   let headerPosition = header.getBoundingClientRect().height;
   let positionScroll = scrollElementTop - headerPosition;
   window.scrollBy({
    top: positionScroll,
    behavior: 'smooth'
   })
  })
 }
}
